/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import {
  useHMSActions,
  useHMSStore,
  selectIsConnectedToRoom,
  selectPeers,
  selectIsLocalAudioEnabled,
  selectIsLocalVideoEnabled,
  selectBroadcastMessages,
  selectSessionId,
  useHMSNotifications,
  HMSNotificationTypes,
  selectIsSomeoneScreenSharing,
  selectPeerScreenSharing,
  selectIsLocalScreenShared,
  selectScreenShareByPeerID,
} from "@100mslive/react-sdk";
import {
  create_hms_room_question_action,
  create_hms_room_question_rating_action,
  delete_hms_room_question_action,
  get_generated_hms_client_token_action,
  get_hms_room_details_action,
  get_hms_room_questions_action,
  get_loggedin_user_meta_data_action,
  unregistered_user_get_generated_hms_client_token_action,
  update_hms_room_question_action,
  update_hms_room_question_rating_action,
} from "../../../redux/_actions";
import { useNavigate, useParams } from "react-router-dom";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";
import { AuthContext } from "../../../_hooks/useAuthContext";

function useJoinScheduledEvent() {
  const { user } = useContext(AuthContext);

  const [hmsGeneratedToken, setHmsGeneratedToken] = useState();
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [hmsRoomDetail, setHmsRoomDetail] = useState({});
  const [showMessages, setShowMessages] = useState(false);
  const [messageForm, setMessageForm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [hmsRoomQuestions, setHmsRoomQuestions] = useState([]);
  const [hmsQuestionForm, setHmsQuestionForm] = useState({});
  const [hmsQuestionCreateLoading, setHmsQuestionCreateLoading] =
    useState(false);
  const [displayRejoinScreen, setdisplayRejoinScreen] = useState(false);
  const [joineesNames, setJoineesNames] = useState([]);
  const [questionRatingLoading, setQuestionRatingLoading] = useState(false);
  const [skills, setSkills] = useState([]);
  const [hmsRoomLoading, setHmsRoomLoading] = useState(false);

  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const hmsActions = useHMSActions();
  const isInviteeJoined = useHMSStore(selectIsConnectedToRoom);
  const peers = useHMSStore(selectPeers);
  const isLocalAudioEnabled = useHMSStore(selectIsLocalAudioEnabled);
  const isLocalVideoEnabled = useHMSStore(selectIsLocalVideoEnabled);
  const brodacastMessages = useHMSStore(selectBroadcastMessages);
  const hmsRoomSessionId = useHMSStore(selectSessionId);

  //regarding screen sharing
  const screenShareOn = useHMSStore(selectIsSomeoneScreenSharing);
  const presenter = useHMSStore(selectPeerScreenSharing);
  const localScreenShared = useHMSStore(selectIsLocalScreenShared);
  const screenShareVideoTrack = useHMSStore(
    selectScreenShareByPeerID(presenter?.id)
  );

  const notification = useHMSNotifications();
  const { hmsGeneratedClientTokenData } = useSelector(
    (state) => state.get_generated_hms_client_token_reducer
  );

  const { hmsRoomDetailData } = useSelector(
    (state) => state.get_hms_room_details_reducer
  );

  const { hmsRoomQuestionsData } = useSelector(
    (state) => state.get_hms_room_questions_reducer
  );

  const { hmsRoomUpdatedQuestionData } = useSelector(
    (state) => state.create_hms_room_question_reducer
  );

  useEffect(() => {
    if (!notification) {
      return;
    }
    switch (notification.type) {
      case HMSNotificationTypes.PEER_JOINED:
        showSuccessMessage(`${notification.data.name} joined`);
        break;
      case HMSNotificationTypes.PEER_LEFT:
        showSuccessMessage(`${notification.data.name} left.`);
        break;
      case HMSNotificationTypes.NEW_MESSAGE:
        showSuccessMessage(`New message in room.`);
        break;
      // case HMSNotificationTypes.PL:
      //       showSuccessMessage(`New message in room.`);
      //     break;
      default:
        return;
    }
  }, [notification]);

  useEffect(() => {
    window.onunload = () => {
      if (isInviteeJoined) {
        hmsActions.leave();
      }
    };
  }, [hmsActions, isInviteeJoined]);

  useEffect(() => {
    const id = params?.id;
    if (id) {
      callRoomDetailsApi(id);
    } else {
      let data = formErrors;
      data["error"] = "Joining Room Id does not exist";
      setFormErrors(data);
    }
  }, []);

  useEffect(() => {
    if (hmsRoomDetailData?.data) {
      setHmsRoomDetail(hmsRoomDetailData?.data);
      getJoineesNames(hmsRoomDetailData?.data);
    }
  }, [hmsRoomDetailData]);

  useEffect(() => {
    if (hmsGeneratedClientTokenData?.data) {
      setHmsGeneratedToken(hmsGeneratedClientTokenData?.data);
      joinHMSRoom(hmsGeneratedClientTokenData?.data);
      getHmsRoomQuestionsList();
    }
  }, [hmsGeneratedClientTokenData]);

  useEffect(() => {
    if (hmsRoomQuestionsData?.data) {
      setHmsRoomQuestions(hmsRoomQuestionsData?.data);
    }
  }, [hmsRoomQuestionsData]);

  useEffect(() => {
    if (hmsRoomUpdatedQuestionData?.data) {
      let data = hmsRoomQuestions;
      data.push(hmsRoomUpdatedQuestionData?.data);
      setHmsRoomQuestions(data);
    }
  }, [hmsRoomUpdatedQuestionData]);

  const callRoomDetailsApi = async (id) => {
    setLoading(true);
    await dispatch(get_hms_room_details_action(id));
    setLoading(false);

    if (user) getLoggedinUserApi();
  };

  const callRegisteredUserTokenApi = async (id) => {
    if (user?.user && user.user?.id) {
      await dispatch(get_generated_hms_client_token_action(id));
    }
  };

  const callUnregisteredUserTokenApi = async (id) => {
    if (hmsRoomDetailData?.data)
      await dispatch(
        unregistered_user_get_generated_hms_client_token_action(id, {
          name: hmsRoomDetailData.data?.name,
          email: hmsRoomDetailData.data?.email,
        })
      );
  };

  const getLoggedinUserApi = async () => {
    setLoading(true);
    await dispatch(get_loggedin_user_meta_data_action());
    setLoading(false);
  };

  const joinHMSRoom = async (token) => {
    await hmsActions.join({
      authToken: token,
      userName: formData?.name,
      settings: {
        isVideoMuted: false,
        isAudioMuted: false,
      },
    });
    setHmsRoomLoading(false);
  };

  const getHmsRoomQuestionsList = async () => {
    if (user?.user && user.user.role === "mentor") {
      await dispatch(get_hms_room_questions_action(hmsRoomDetail?.room_id));
    }
  };

  const onJoinClick = async () => {
    let data = formErrors;

    if (formData?.name) {
      if (formData.name.length !== 0) {
        if (user?.user) {
          setHmsRoomLoading(true);
          callRegisteredUserTokenApi(hmsRoomDetail?.room_id);
        } else callUnregisteredUserTokenApi(hmsRoomDetail?.room_id);
      } else {
        data["error"] = "Please Enter your name.";
        showWarningMessage("Please Enter your name.");
      }
    } else {
      // showWarningMessage("Joining token does not exist");
      showWarningMessage("Please Enter your name");
    }
    setFormErrors(data);
  };

  const onFormInputChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = formData;

    data[name] = value;

    setFormData(data);
  };

  const onCallEndClick = () => {
    hmsActions.leave();
    setdisplayRejoinScreen(true);
  };
  const toggleAudioClick = async () => {
    await hmsActions.setLocalAudioEnabled(!isLocalAudioEnabled);
  };
  const toggleVideoClick = async () => {
    await hmsActions.setLocalVideoEnabled(!isLocalVideoEnabled);
  };

  const onBackClick = () => {
    navigate(-1);
  };

  const navigateHome = () => {
    navigate("/dashboard");
  };

  const onShowMessagesClick = () => {
    setShowMessages((prev) => !prev);
  };

  const sendBroadCastMessage = (e) => {
    e.preventDefault();
    hmsActions.sendBroadcastMessage(messageForm);
    setMessageForm("");
  };

  const onMessageFormChange = (e) => {
    const value = e.target.value;

    setMessageForm(value);
  };

  //// for questions
  const handleModalOpen = () => {
    if (!modalOpen) {
      let data = hmsQuestionForm;
      data["unix_timestamp"] = Math.floor(Date.now() / 1000);
      setFormData(data);
      setSkills([]);
    }

    setModalOpen((e) => !modalOpen);
    setHmsQuestionForm({});
  };

  const onHmsQuestionFormChange = (e, isSkill) => {
    let data = hmsQuestionForm;

    if (isSkill) {
      data["skills"] = [];
      data.skills.push(e);
      setSkills(data["skills"]);
    } else {
      let name = e.target.name;
      let value = e.target.value;
      data[name] = value;
    }
    setHmsQuestionForm(data);
  };
  const onHmsQuestionCreateClick = async () => {
    setHmsQuestionCreateLoading(true);
    let id = hmsQuestionForm?.id;
    let data = hmsQuestionForm;

    if (data?.question && data?.skills) {
      if (hmsQuestionForm?.id) {
        await dispatch(update_hms_room_question_action(id, data));
      } else {
        if (hmsRoomDetail?.mentor) {
          data["room_id"] = hmsRoomDetail?.room_id;
          data["answered_by"] = hmsRoomDetail?.candidate?.id;
          data["created_by"] = hmsRoomDetail?.mentor?.id;
          data["session_id"] = hmsRoomSessionId;
          data["unix_timestamp"] = Math.floor(Date.now() / 1000);
          await dispatch(create_hms_room_question_action(data));
        }
      }
      await dispatch(get_hms_room_questions_action(hmsRoomDetail?.room_id));
      setHmsQuestionForm({});
      setSkills([]);
      setHmsQuestionCreateLoading(false);
      setModalOpen(false);
    } else {
      if (!data?.question) {
        showWarningMessage("Please enter the question");
      } else {
        showWarningMessage("Please enter the skill name");
      }
    }
  };

  const getJoineesNames = (hmsRoom) => {
    let arr = [];
    if (hmsRoom?.candidate !== null) {
      if (arr[0]) arr[1] = hmsRoom.candidate?.full_name;
      else arr[0] = hmsRoom.candidate?.full_name;
    }
    if (hmsRoom?.hiring_manager !== null) {
      if (arr[0]) arr[1] = hmsRoom.hiring_manager?.full_name;
      else arr[0] = hmsRoom.hiring_manager?.full_name;
    }
    if (hmsRoom?.mentor !== null) {
      if (arr[0]) arr[1] = hmsRoom.mentor?.full_name;
      else arr[0] = hmsRoom.mentor?.full_name;
    }
    if (hmsRoom?.name !== null) {
      if (arr[0]) arr[1] = hmsRoom?.name;
      else arr[0] = hmsRoom?.name;
    }
    setJoineesNames(arr);
  };

  const onRejoinClick = () => {
    setdisplayRejoinScreen(false);
    onJoinClick();
  };

  const onQuestionRatingChange = async (value, question) => {
    if (user?.user && user.user?.id === question?.created_by) {
      setQuestionRatingLoading(true);
      let data = {
        hms_question: question?.id,
        skill: question?.skills && question.skills[0],
        rating: value,
      };
      if (question?.rating === undefined || question?.rating === null)
        await dispatch(create_hms_room_question_rating_action(data));
      else
        await dispatch(
          update_hms_room_question_rating_action(question?.id, data)
        );
      getHmsRoomQuestionsList();
      setQuestionRatingLoading(false);
    }
  };

  const onScreenShareClick = async () => {
    try {
      if (localScreenShared) await hmsActions.setScreenShareEnabled(false);
      else await hmsActions.setScreenShareEnabled(true, { videoOnly: true });
    } catch (error) {
      console.log(error);
    }
  };

  const onEndInterviewClick = async () => {
    try {
      const lock = true;
      const reason = "Interview completed";
      await hmsActions.endRoom(lock, reason);

      navigate("/dashboard");
    } catch (error) {
      console.error(error);
      showWarningMessage(error);
    }
  };

  const onDeleteHmsQuestion = async (id) => {
    if (id) {
      await dispatch(delete_hms_room_question_action(id));
      await dispatch(get_hms_room_questions_action(hmsRoomDetail?.room_id));
    }
  };

  const onEditQuestionClick = async (question) => {
    setModalOpen(true);
    let data = {};
    data.id = question.id;
    data.question = question.question;
    data.skills = question.skill_tag;
    setSkills(data.skills);
    setHmsQuestionForm(data);
  };

  return {
    loading,
    formData,
    formErrors,
    isInviteeJoined,
    peers,
    isLocalAudioEnabled,
    isLocalVideoEnabled,
    hmsRoomDetail,
    brodacastMessages,
    showMessages,
    messageForm,
    modalOpen,
    hmsRoomQuestions,
    hmsQuestionCreateLoading,
    hmsQuestionForm,
    user,
    displayRejoinScreen,
    joineesNames,
    questionRatingLoading,

    screenShareOn,
    presenter,
    localScreenShared,
    screenShareVideoTrack,
    skills,
    hmsRoomLoading,
    onFormInputChange,
    onJoinClick,
    onCallEndClick,
    toggleAudioClick,
    toggleVideoClick,
    onBackClick,
    navigateHome,
    sendBroadCastMessage,
    onShowMessagesClick,
    onMessageFormChange,
    handleModalOpen,
    onHmsQuestionFormChange,
    onHmsQuestionCreateClick,
    onRejoinClick,
    onQuestionRatingChange,
    onScreenShareClick,
    onEndInterviewClick,
    onDeleteHmsQuestion,
    onEditQuestionClick,
  };
}

export default useJoinScheduledEvent;
